import Upload from './src/upload';
import Message from '../message';

Upload.install = function(Vue) {
	Vue.component(Upload.name, Upload);
	Vue.prototype.$message = Message;
};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/upload/index.js